import request from '@/utils/request'

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    accountName:username,
    pwd:password,
    // code,
    // uuid
  }
  return request({
    url: '/yg-plat-manage/manage/loginManage',
    // url: '/manage/loginManage',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data,
    // baseURL:"http://192.168.6.246:20100"
  })
}

// 注册方法
export function register(data) {
  return request({
    url: '/register',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    // url: '/logout',
    url: '/yg-plat-manage/manage/loginOutManage',
    method: 'post'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}